<button
	class="chat-toggle-button"
	[class.chat-toggle-button--active]="isOpen()"
	(click)="toggle()"
	aria-label="Toggle AI chat assistant"
	[attr.aria-expanded]="isOpen()"
>
	<md-icon [icon]="'untitled-ui/communication/message-chat-circle'"></md-icon>
</button>
